// import { ApiService } from '../../../services/api_service';
import formStyle from '../../../core/forms/style/WForm.less';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WActionButton } from '../../../core/elements/WActionButton';
import { WFormFieldSelect } from '../../../core/forms/WFormFramework';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';
import { WHelpIcon } from '../../../core/elements/WHelpIcon';
import { WSpinner } from '../../../core/elements/spinner/WSpinner';
import { Features } from '../../../control/features';
import { hasFeature } from '../../../control/hasFeature';

interface DatenverwaltungGewerkegruppenProps extends React.ClassAttributes<any> {
    data: any;
}

interface DatenverwaltungGewerkegruppenState {
    showGruppeEdit: boolean
    showSpinner: boolean;
    inputBereich: number;
    inputGewerk: number;
    inputWz: number;
    selectedWz: number[];
}

export class DatenverwaltungGewerkegruppen extends React.Component<DatenverwaltungGewerkegruppenProps, DatenverwaltungGewerkegruppenState> {

    constructor(props: any) {
        super(props);
        this.state = {
            showGruppeEdit: false,
            showSpinner: false,
            inputBereich: null,
            inputGewerk: null,
            inputWz: null,
            selectedWz: []
        };
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    private lastFormTid: number;

    render(): JSX.Element {
        const data = this.props.data[IDs.ENT_GEWERKE_GRUPPE];
        data.forEach((r: any) => {
            let selectedWz;
            try {
                selectedWz = JSON.parse(r.daten);
            } catch (e) {
            }
            if (Array.isArray(selectedWz)) {
                r.gewerke_wz = <div
                    style={{
                        display: 'flex', flexDirection: 'column', flex: 1, border: '1px solid lightgray', borderRadius: 3, minHeight: 50,
                        padding: 5
                    }}
                >
                    {this.renderSelectedWzList(false, selectedWz)}
                </div>;
            }
        });

        return (
            <div>
                <WFormsTableWrapper
                    entity={IDs.ENT_GEWERKE_GRUPPE}
                    module={IDs.MOD_ETOOL_ADMIN}
                    actions={['add', 'edit', 'delete']}
                    customClass={'Custom-ETA'}
                    formLayout={'flowV2'}
                    data={data}
                    columnWidths={[200, 300]}
                    extraFormElementAfter={{
                        beschreibung: this.renderGewerkegruppe()
                    }}
                    customColumns={[
                        {
                            id: 'gewerke_wz',
                            accessor: 'gewerke_wz',
                            Header: 'Gewerke und Wirtschaftszweige',
                            HeaderText: 'Gewerke und Wirtschaftszweige',
                            filterable: false
                        }
                    ]}
                    callBeforeOnFormSave={(formData: any, callback: () => void) => {
                        formData.daten = JSON.stringify(this.state.selectedWz);
                        callback();
                    }}
                    validateField={(key: string, value: any, data: any) => {
                        const formValues = data.values || {};
                        if (this.lastFormTid !== formValues.tid) {
                            if (formValues.tid > 0) {
                                let selectedWz;
                                try {
                                    selectedWz = JSON.parse(formValues.daten);
                                } catch (e) {
                                    console.error(e, formValues);
                                }
                                if (Array.isArray(selectedWz)) {
                                    this.setState({ selectedWz });
                                }
                            } else if (formValues.tid === 0) {
                                this.setState({ showGruppeEdit: true });
                            }
                            this.lastFormTid = formValues.tid;
                        }
                        return null;
                    }}
                    onAfterAction={(action: string) => {
                        if (action.startsWith('closeForm')) {
                            this.lastFormTid = null;
                            this.setState({ selectedWz: [], showGruppeEdit: false, inputBereich: null, inputGewerk: null, inputWz: null });
                        }
                        if (action === 'saveDone' || action === 'delDone') {
                            this.triggerService.fire('admin_reload', IDs.ENT_GEWERKE_GRUPPE);
                        }
                    }}
                />
                {this.state.showSpinner && <WSpinner />}
            </div>
        );
    }

    renderGewerkegruppe(): JSX.Element {
        return (
            <div style={{ display: 'flex', flexDirection: 'column' }}>
                {this.state.showGruppeEdit &&
                    <div>
                        <div className={formStyle.formTitel} style={{ marginBottom: 20 }}>Bitte Gewerke und Wirtschaftszweige auswählen</div>
                        {this.renderInputBereich()}
                        {this.renderInputGewerk()}
                        {this.renderInputWz()}
                    </div>}
                {this.renderSelectedWz()}
            </div>
        );
    }

    renderInputBereich(): JSX.Element {
        const bereiche = (this.props.data[IDs.ENT_BRANCHEN_BEREICHE] || []).filter((r: any) => hasFeature(Features.DV_GEWERKEGRUPPEN, r.intern_key));
        return (
            <div className={formStyle.fieldBox}>
                <div className={formStyle.label} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0' }}>
                    Bereich
                    <WHelpIcon
                        key={`${IDs.MOD_ETOOL_ADMIN}_${IDs.ENT_GEWERKE_GRUPPE}_bereich`}
                        helpKey={`${IDs.MOD_ETOOL_ADMIN}_${IDs.ENT_GEWERKE_GRUPPE}_bereich`}
                        data={this.props.data}
                        styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                        label='Info "Bereich"'
                        type='info'
                        editBar={true}
                    />
                </div>
                <div className={formStyle.input} style={{ flexDirection: 'row', paddingBottom: 0 }}>
                    <WFormFieldSelect
                        key={'inputBereich'}
                        label={null}
                        name={'bereich'}
                        value={this.state.inputBereich + ''}
                        onValueChange={(name, value) => this.setState({ inputBereich: value, inputGewerk: null, inputWz: null })}
                        options={bereiche}
                    />
                </div>
            </div>
        );
    }

    renderInputGewerk(): JSX.Element {
        const fndGewerk = (this.props.data[IDs.ENT_BRANCHEN_BEREICHE] || []).find((r: any) => r.tid === this.state.inputBereich);
        const gewerke = (this.props.data[IDs.ENT_BRANCHEN_GEWERKE] || []).filter((r: any) => fndGewerk && r.bereich_key_orig === fndGewerk.intern_key);
        return (
            <div className={formStyle.fieldBox}>
                <div className={formStyle.label} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0' }}>
                    Gewerk
                    <WHelpIcon
                        key={`${IDs.MOD_ETOOL_ADMIN}_${IDs.ENT_GEWERKE_GRUPPE}_gewerk`}
                        helpKey={`${IDs.MOD_ETOOL_ADMIN}_${IDs.ENT_GEWERKE_GRUPPE}_gewerk`}
                        data={this.props.data}
                        styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                        label='Info "Gewerk"'
                        type='info'
                        editBar={true}
                    />
                </div>
                <div className={formStyle.input} style={{ flexDirection: 'row', paddingBottom: 0 }}>
                    <WFormFieldSelect
                        key={`inputGewerk_${this.state.inputBereich}`}
                        label={null}
                        name={'gewerk'}
                        value={this.state.inputGewerk + ''}
                        onValueChange={(name, value) => this.setState({ inputGewerk: value, inputWz: null })}
                        options={gewerke}
                    />
                </div>
            </div>
        );
    }

    renderInputWz(): JSX.Element {
        const wz: any[] = (this.props.data[IDs.ENT_GEWERKE_WZ] || []).filter((r: any) => r.gewerk_tid_orig === this.state.inputGewerk);
        if (wz.length === 1 && this.state.inputWz !== wz[0].tid) {
            this.setState({ inputWz: wz[0].tid });
        }
        return (
            <div className={formStyle.fieldBox}>
                <div className={formStyle.label} style={{ display: 'flex', justifyContent: 'space-between', padding: '5px 0' }}>
                    Wirtschaftszweig
                    <WHelpIcon
                        key={`${IDs.MOD_ETOOL_ADMIN}_${IDs.ENT_GEWERKE_GRUPPE}_wz`}
                        helpKey={`${IDs.MOD_ETOOL_ADMIN}_${IDs.ENT_GEWERKE_GRUPPE}_wz`}
                        data={this.props.data}
                        styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                        label='Info "Wirtschaftszweig"'
                        type='info'
                        editBar={true}
                    />
                </div>
                <div className={formStyle.input} style={{ flexDirection: 'column', paddingBottom: 0 }}>
                    <WFormFieldSelect
                        key={`inputWz_${this.state.inputGewerk}`}
                        label={null}
                        name={'wz'}
                        value={this.state.inputWz + ''}
                        onValueChange={(name, value) => this.setState({ inputWz: value })}
                        options={wz}
                        output={["B:WZ 2003:", "code_2003", "bezeichnung_2003", "\n", "B:WZ 2008:", "code_2008", "bezeichnung_2008"]}
                    />
                    <div style={{ display: 'flex', flexDirection: 'row', paddingBottom: 20 }}>
                        {this.state.inputWz &&
                            <WActionButton
                                key='btn_add_wz'
                                insideText='Ausgewählte WZ hinzufügen'
                                label='Ausgewählte WZ hinzufügen'
                                action=''
                                insideLeftMargin={0}
                                styleProps={{ height: 40, fontSize: 12, marginRight: 10 }}
                                // disabled={!this.state.inputWz}
                                onAction={() => {
                                    const { selectedWz, inputWz } = this.state;
                                    if (selectedWz.indexOf(inputWz) === -1) {
                                        selectedWz.push(inputWz);
                                        selectedWz.sort((a, b) => a - b);
                                        this.setState({ selectedWz });
                                    } else {
                                        alert('Der WZ wurde hinzugefügt.');
                                    }
                                }}
                            />
                        }
                        {this.state.inputGewerk && wz.length > 0 &&
                            <WActionButton
                                key='btn_add_allwz'
                                insideText='Alle WZ des ausgewählten Gewerkes hinzufügen'
                                label='Alle WZ des ausgewählten Gewerkes hinzufügen'
                                action=''
                                insideLeftMargin={0}
                                styleProps={{ height: 40, fontSize: 12 }}
                                // disabled={!this.state.inputGewerk}
                                onAction={() => {
                                    const selectedWz = [...this.state.selectedWz];
                                    wz.forEach((w: any) => {
                                        if (selectedWz.indexOf(w.tid) === -1) {
                                            selectedWz.push(w.tid);
                                        }
                                    });
                                    selectedWz.sort((a, b) => a - b);
                                    if (JSON.stringify(selectedWz) !== JSON.stringify(this.state.selectedWz)) {
                                        this.setState({ selectedWz });
                                    } else {
                                        alert('Die WZ wurden hinzugefügt.');
                                    }
                                }}
                            />}
                    </div>
                </div>
            </div>
        );
    }

    renderSelectedWz(): JSX.Element {
        return (
            <div>
                <div className={formStyle.fieldBox}>
                    <div className={formStyle.label} style={{ display: 'flex', justifyContent: 'space-between' }}>
                        Gewerke und Wirtschaftszweige
                        <WHelpIcon
                            key={`${IDs.MOD_ETOOL_ADMIN}_${IDs.ENT_GEWERKE_GRUPPE}_daten`}
                            helpKey={`${IDs.MOD_ETOOL_ADMIN}_${IDs.ENT_GEWERKE_GRUPPE}_daten`}
                            data={this.props.data}
                            styleProps={{ width: 18, height: 18, borderRadius: 10, backgroundColor: '#b9cde5', verticalAlign: 'top', margin: 0 }}
                            label='Info "Gewerke und Wirtschaftszweige"'
                            type='info'
                            editBar={true}
                        />
                    </div>
                    <div className={formStyle.input} style={{ flexDirection: 'row', paddingBottom: 0 }}>
                        <div
                            style={{
                                display: 'flex', flexDirection: 'column', flex: 1, border: '1px solid lightgray', borderRadius: 3,
                                minHeight: 50, maxHeight: 200, overflowX: 'hidden', overflowY: 'auto', padding: 5, marginRight: 5
                            }}>
                            {this.renderSelectedWzList(this.state.showGruppeEdit)}
                        </div>
                        {!this.state.showGruppeEdit && <div style={{ width: 'auto' }}>
                            <WActionButton
                                key='btn_edit_gewerke_gruppe'
                                tooltip='Bearbeiten'
                                label='Bearbeiten'
                                action='edit'
                                styleProps={{ marginRight: 2 }}
                                onAction={() => this.setState({ showGruppeEdit: true })}
                            />
                        </div>}
                    </div>
                </div>
            </div >
        );
    }

    renderSelectedWzList(editable?: boolean, selectedWz?: number[]): JSX.Element {
        if (!selectedWz) {
            selectedWz = this.state.selectedWz;
        }
        const showDelBtn = editable;

        const wz = (this.props.data[IDs.ENT_GEWERKE_WZ] || []).filter((w: any) => selectedWz.indexOf(w.tid) !== -1);
        const gewerke = (this.props.data[IDs.ENT_BRANCHEN_GEWERKE] || []).filter((g: any) => wz.find((w: any) => w.gewerk_tid_orig === g.tid));
        const gewerkeWzMap: any = {};
        gewerke.forEach((g: any) => {
            gewerkeWzMap[g.tid] = wz.filter((w: any) => w.gewerk_tid_orig === g.tid);
        });
        let gewerkeTids = gewerke.map((g: any) => g.tid);
        gewerkeTids = gewerkeTids.sort((a: number, b: number) => {
            const g1 = gewerke.find((g: any) => g.tid === a);
            const g2 = gewerke.find((g: any) => g.tid === b);
            if (g1.name > g2.name) {
                return 1;
            }
            if (g1.name < g2.name) {
                return -1;
            }
            return 0;
        });

        return (
            <div>
                {gewerkeTids.map((gtid: string) => {
                    const gData = gewerke.find((g: any) => g.tid === +gtid);
                    return <div style={{ display: 'flex', flexDirection: 'column' }}>
                        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 5 }}>
                            {showDelBtn && <button
                                title={'Gewerk entfernen'}
                                style={{ marginRight: 10 }}
                                onClick={() => this.removeSelectedWz(gData.tid, null)}
                            >{String.fromCharCode(10005)}</button>}
                            <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontWeight: 'bold' }} title={gData.name}>
                                {gData.name}
                            </div>
                        </div>
                        {gewerkeWzMap[gtid].map((wData: any) =>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 35, marginBottom: 5 }}>
                                {showDelBtn && <button
                                    title={'WZ entfernen'}
                                    style={{ marginRight: 10 }}
                                    onClick={() => this.removeSelectedWz(null, wData.tid)}
                                >{String.fromCharCode(10005)}</button>}
                                <div style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={wData.name}>
                                    {/* ["B:WZ 2003:", "code_2003", "bezeichnung_2003", "\n", "B:WZ 2008:", "code_2008", "bezeichnung_2008"] */}
                                    <div title={`${wData.code_2003} ${wData.bezeichnung_2003}`}>
                                        <span style={{ fontWeight: 'bold' }}>WZ 2003:&nbsp;</span><span>{`${wData.code_2003 || '-'} ${wData.bezeichnung_2003 || '-'}`}</span>
                                    </div>
                                    <div title={`${wData.code_2008} ${wData.bezeichnung_2008}`}>
                                        <span style={{ fontWeight: 'bold' }}>WZ 2008:&nbsp;</span><span>{`${wData.code_2008 || '-'} ${wData.bezeichnung_2008 || '-'}`}</span>
                                    </div>
                                </div>
                            </div>)}
                    </div>
                })}
            </div>
        );
    }

    removeSelectedWz(gewerkTid: number, wzTid: number) {
        const { selectedWz } = this.state;
        if (gewerkTid) {
            const wz = (this.props.data[IDs.ENT_GEWERKE_WZ] || []).filter((w: any) => selectedWz.indexOf(w.tid) !== -1 && w.gewerk_tid_orig === gewerkTid);
            wz.forEach((w: any) => {
                const idx = selectedWz.findIndex((tid: number) => tid === w.tid);
                selectedWz.splice(idx, 1);
            });
        } else if (wzTid) {
            const idx = selectedWz.findIndex((tid: number) => tid === wzTid);
            selectedWz.splice(idx, 1);
        }
        // console.log(selectedWz);
        this.setState({ selectedWz });
    }
}
